<p class="breadcrumb">
  @for (breadcrumb of selectedAreaBreadcrumb(); track breadcrumb.areaId; let last = $last) {
    <span
      (click)="areaClicked.emit(breadcrumb.areaId)"
      [attr.data-cy]="'navigation-breadcrumb-area-' + breadcrumb.areaId"
      [class.active]="breadcrumb.active"
      [class.link]="!breadcrumb.active"
    >
      {{ breadcrumb.name | localizedString }}
    </span>
    @if (!breadcrumb.active && !last) {
      <cue-icon [icon]="ICONS.cueArrowRight" />
    }
  }
</p>
